import React, {Fragment, useState} from 'react';
import {getBackgroundImg, getPublicImagePath} from '@nutastic/nutastic-react-app';
import Fade from 'react-reveal/Fade';
import Footer from "../Footer";
import StoryModal from "../StoryModal";

const HomePage = () => {
    const componentClass = 'home-page';
    const [modalIsOpen, setModalIsOpen] = useState(false);

    return <Fragment>
        <section className={`${componentClass}__header`}>
            <img src={getPublicImagePath('home--banner-text.png')} className={`${componentClass}__welcomeSign`} alt="We Are Up To Serve | Unmask Purpose" />
        </section>

        <section className="aboutSection">
            <Fade>
                <div className="container">
                    <div className={`${componentClass}__missionVision`}>
                        <h1 className="theMission">The Mission<i>Freedom</i></h1>
                        <h1 className="theVision">The Vision<i>Mask Off</i></h1>
                    </div>
                    <p className="aboutSection__blurb">
                        Join us as we build a community of sisterhood to serve in faith and live on purpose
                    </p>
                    <div className="aboutSection__buttons">
                        <a className="btn btn-outline-white" href="https://podcasts.apple.com/us/podcast/unmask-purpose-podcast/id1596936605" target="_blank" rel="noreferrer">Unmask Podcast</a>
                        <span className="btn btn-white" onClick={() => setModalIsOpen(true)}>Learn More</span>
                        <a className="btn btn-outline-white" href="https://www.youtube.com/@UnmaskPurposePod" target="_blank" rel="noreferrer">Watch Us Online</a>
                    </div>
                </div>
            </Fade>
        </section>

        <section className="storySection">
            <Fade left={true}>
                <div className="storySection__image" style={getBackgroundImg(getPublicImagePath('up-1.jpg'))} />
            </Fade>
            <Fade delay={250}>
                <div className="storySection__details background-black">
                    <h1 className="isCursive">the Lifestyle</h1>
                    <div className="icon-divider">
                        <i className="ion-ios-infinite" />
                    </div>
                    <p>
                        Unmasking is a lifestyle of serving, building, and honoring the person God has called us to be.
                        It's about stepping out in faith each day and embracing the purpose in both joy and challenges.
                        <br /><br />
                        Unmasking is freeing yourself from everything that's not of you, building yourself up brick by brick, & celebrating what it takes to be YoU.
                        You are PURPOSE, living on PURPOSE.
                    </p>
                    <button className="btn btn-outline-white" onClick={() => setModalIsOpen(true)}>Learn More</button>
                </div>
            </Fade>
        </section>

        <section className="storySection storySection--flipped">
            <Fade right={true}><div className="storySection__image" style={getBackgroundImg(getPublicImagePath('up-2.jpg'))} /></Fade>
            <Fade delay={250}>
                <div className="storySection__details background-black">
                    <h1 className="isCursive">the Journey</h1>
                    <div className="icon-divider">
                        <i className="ion-ios-infinite" />
                    </div>
                    <p>
                        Our goal is to be an example of unmasking daily by stepping into our purpose, being authentic to who God created us to be, and following where He
                        leads to build us up in His image.
                        <br /><br />
                        Join us this journey as we unmask, serve, and grow in our daily lives. We are building brick by brick with big faith to live on purpose!
                    </p>
                    <button className="btn btn-outline-white" onClick={() => setModalIsOpen(true)}>Learn More</button>
                </div>
            </Fade>
        </section>

        <Footer />

        <StoryModal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)} title="About Unmask Purpose" />
    </Fragment>;
};

export default HomePage;
